<script>
import { event } from "vue-analytics";
import Burguer from "./Burguer";

import ClickOutside from "vue-click-outside";
import { mapState, mapActions } from "vuex";
import support from "@/utils/support";

export default {
  components: {
    Burguer
  },
  directives: {
    ClickOutside
  },
  data() {
    return {
      dropdownVisible: false
    };
  },
  methods: {
    ...mapActions("user", ["logout"]),
    ...mapActions("menu", ["changeMenu"]),
    callLogout() {
      event("cliente", "click", "Menu:sair");
      this.logout();
      support.clearSession();
      document.location.reload(true);
    },
    closeDropdown() {
      if (this.dropdownVisible) this.dropdownVisible = false;
    },
    changeDropdown() {
      event("cliente", "click", "Menu:perfil");
      this.dropdownVisible = !this.dropdownVisible;
    },
    isActiveRoute(name) {
      return this.$route.name === name;
    },

    sendEvents(name) {
      event("cliente", "click", `Menu:${name}`);
    }
  },
  computed: {
    ...mapState("user", ["user"])
  }
};
</script>

<template>
  <div class="menu">
    <div class="container">
      <burguer class="mobile-only" />

    <div @click="changeMenu()">
      <router-link @click="clickedOn()" :to="{name: 'dashboard'}" class="logo">
        <img src="/static/logo-vertical.svg" />
      </router-link>
    </div>

      <ul class="list" v-if="user">
        <li @click="changeMenu()" :class="{'active': isActiveRoute('purchase-flow')}">
          <router-link
            :to="{name: 'purchase-flow'}"
          >
            <img src="/static/menu-services.svg" />agendar limpezas
          </router-link>
        </li>

        <li @click="changeMenu('orders')">
          <img src="/static/menu-orders.svg" />minhas limpezas
        </li>
        <li @click="changeMenu()" :class="{'active': isActiveRoute('help')}">
          <router-link
            @click.native="sendEvents('help')"
            :to="{name: 'help'}"
          >
            <img src="/static/icon-question.svg" />regras e infos
          </router-link>
        </li>
      </ul>

      <ul class="user" v-if="user">
        <li class="dashboard" :class="{active: $route.name === 'dashboard'}">
          <router-link :to="{name: 'dashboard'}">
            <img src="/static/dashboard.svg" />
          </router-link>
        </li>
        <div class="user-image" @click="changeDropdown">
          <img :src="user.profile.profile_picture" :alt="`${user.first_name} ${user.last_name}`" @error="$event.target.src='/static/whats-share/donie.svg'"/>
        </div>

        <div class="dropdown" @click="dropdownVisible = !dropdownVisible">
          <img src="/static/arrow-down.svg" width="10px" />

          <transition name="down" mode="in-out">
            <div class="dropdown-menu" v-click-outside="closeDropdown" v-if="dropdownVisible">
              <router-link
                @click.native="sendEvents('personal-data')"
                :to="{name: 'personal-data'}">
                Minha Conta
              </router-link>
              <span @click="callLogout">Sair</span>
            </div>
          </transition>
        </div>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.menu {
  display: inline-flex;
  position: relative;
  width: 100%;
  height: 70px;
  left: 0;
  top: 0;
  color: #fff;
  background: linear-gradient(90deg, var(--purple) 0%, var(--pink) 100%);
  z-index: 3;
}

.menu[fixed="true"] {
  position: fixed;
}

.menu .logo {
  position: absolute;
  background: #fff;
  width: 180px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0 0 6px 6px;
  box-shadow: 5px 5px 20px -10px rgba(0, 0, 0, 0.7);
  z-index: 10;
}

.menu .logo img {
  width: 80%;
  height: 80%;
  object-fit: contain;
}

.menu ul.list {
  margin: 0 0 0 230px;
  padding: 0;
  height: 70px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  list-style-type: none;
}

.menu ul.list li,
.menu ul.list li a {
  color: #fff;
  font-weight: 400;
  font-size: 18px;
  display: inline-flex;
  align-items: center;
  /* margin-right: 20px; */
  padding: 0 15px;
  cursor: pointer;
  transition: all 0.25s ease;
  height: 100%;
}

.menu ul.list li:hover,
.menu ul.list li.active {
  border-top: 8px solid rgba(255, 255, 255, 0.9);
}

.menu ul.list li img {
  height: 25px;
  padding-right: 10px;
}

.menu .user {
  float: right;
  margin: 0;
  padding: 0;
  height: 70px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  list-style-type: none;
  cursor: pointer;
  list-style-type: none;
  -webkit-tap-highlight-color: transparent;
}

.menu .user li {
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  transition: all 0.25s ease;
  height: 100%;
}

.menu .user li.dashboard {
  display: none;
}

.menu .user li.notification span {
  font-size: 9px;
  font-weight: 900;
  margin-top: -15px;
  margin-left: -12px;
  color: var(--purple);
  background: #45e9df;
  border-radius: 2px;
  padding: 2px;
}

.menu .user li.active {
  border-top: 8px solid rgba(255, 255, 255, 0.9);
}

.menu .user li img {
  height: 18px;
  margin-right: 5px;
}

.menu .user div.user-image > img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 100%;
  border: 3px solid #fff;
  margin: 10px;
}

.dropdown {
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: all 0.25s ease;
  height: 100%;
}

.dropdown img {
  width: 10px;
}

.dropdown-menu {
  display: flex;
  flex-direction: column;
  position: absolute;
  margin-left: -50px;
  margin-top: 60px;
  background: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 14px;
  box-shadow: 5px 5px 20px -10px rgba(0, 0, 0, 0.7);
  transition: all 0.23s ease;
}

.dropdown-menu span {
  text-align: right;
  color: initial;
  padding: 5px 0;
  transition: all 0.23s ease;
}

.dropdown-menu span:hover {
  transform: scale(1.1);
}

.mobile-only {
  display: none;
}

@media (max-width: 1200px) {
  .menu ul.list,
  .sub-menu ul.list {
    margin: 0 0 0 200px !important;
  }
  .menu ul.list li {
    font-size: 16px;
    margin-right: 0;
  }
}

@media (max-width: 992px) {
  .menu .user li.dashboard {
    display: inherit;
  }
  .menu ul.list,
  .menu .logo {
    display: none !important;
  }
  .menu {
    display: block !important;
  }
  .mobile-only {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar/Menu.vue